module.exports = __webpack_public_path__ + "static/media/instagram.a091ceeb.svg";